import { Tabs, withStyles } from '@material-ui/core';
import React from 'react';

export default withStyles(() => ({
  root: {
    borderBottom: '1px solid #e8e8e8',
    background: '#f7f7f7',
  },
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > span': {
      maxWidth: 40,
      width: '100%',
      backgroundColor: '#635ee7',
    },
  },
}))((props: any) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);
